"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var JSchema_1 = require("../JSchema");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyObject = /** @class */ (function (_super) {
    __extends(WrappedPropertyObject, _super);
    function WrappedPropertyObject(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        var internal = _this._internal;
        internal.schemaprops = schema.properties;
        internal.cacheProp = {};
        var mparent = (internal.mparent = parent[propName]);
        functions_1.initVue(_this, _this._internal);
        if (internal.schemaprops) {
            if (mparent === undefined) {
                var defvalue = JSchema_1.defaultValue(schema, true);
                options.Vue.set(parent, propName, defvalue);
                internal.mparent = mparent = parent[propName];
            }
            // tworzenie property
            var required = schema.required || [];
            var _loop_1 = function (key) {
                if (internal.schemaprops.hasOwnProperty(key)) {
                    var element_1 = internal.schemaprops[key];
                    if ((element_1.fieldRequired === undefined) && (required.indexOf(key) > -1)) {
                        element_1.fieldRequired = true;
                    }
                    // setTimeout(function() {
                    // self.wrapProperty(obj, mparent, key, element);
                    // let proptime = (new Date()).getTime();
                    if (this_1._options.wrapAll) {
                        var prop = (this_1[key] = new WrappedPropertyCtor_1.default[element_1.type](this_1, mparent, key, element_1, options));
                        if (this_1.$dirty) {
                            prop.$dirty = true;
                        }
                    }
                    else {
                        Object.defineProperty(this_1, key, {
                            enumerable: true,
                            get: function () {
                                var prop = internal.cacheProp[key];
                                if (prop === undefined) {
                                    prop = internal.cacheProp[key] = new WrappedPropertyCtor_1.default[element_1.type](this, mparent, key, element_1, options);
                                    if (this.$dirty) {
                                        prop.$dirty = true;
                                    }
                                }
                                return prop;
                            }
                        });
                        // console.log('prop time 1', key, (new Date()).getTime() - proptime);
                        // trzeba utworzyć tabele jeśli są undefined w modelu
                        if (element_1.type === 'array' || mparent[key] === undefined || functions_1.anyCalc(element_1)) {
                            var prop = internal.cacheProp[key] = new WrappedPropertyCtor_1.default[element_1.type](this_1, mparent, key, element_1, options);
                            if (this_1.$dirty) {
                                prop.$dirty = true;
                            }
                        }
                    }
                    // console.log('prop time', key, (new Date()).getTime() - proptime);
                }
            };
            var this_1 = this;
            for (var key in internal.schemaprops) {
                _loop_1(key);
            }
        }
        return _this;
    }
    WrappedPropertyObject.prototype.$setData = function (value, path, fixArraySize) {
        // /Vue.set(parent, propName, value);
        return JSchema_1.setData(this._internal.schema, this.$model, value, path, 0, this._options.Vue, fixArraySize);
    };
    WrappedPropertyObject.prototype.$validate = function (value) {
        this.$dirty = true;
        if (!this.$parent) {
            // self.startDirty = true;
            this._internal.options.startDirty = true;
        }
        return null;
        /*
            if (value === undefined) {
                value = mparent;
            }
            */
    };
    WrappedPropertyObject.prototype.$validateAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        this.$dirty = true;
        for (var key in this._internal.schemaprops) {
            this[key].$validateAll(result);
        }
        return result;
    };
    WrappedPropertyObject.prototype.$reset = function () {
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop !== undefined) {
                prop.$reset();
            }
        }
        this.$dirty = false;
        if (!this.$parent) {
            this._internal.options.startDirty = false;
        }
        this.$error = null;
    };
    WrappedPropertyObject.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop) {
                prop.$dirtyList(result);
            }
        }
        return result;
    };
    return WrappedPropertyObject;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyObject;
WrappedPropertyCtor_1.default.object = WrappedPropertyObject;
//# sourceMappingURL=WrappedPropertyObject.js.map